import {
  adminAddUserToGroup,
  adminRemoveUserFromGroup,
} from '@akin-home/accounts-frontend';
import { useSignOut } from '@akin-home/auth/react';
import { CognitoUserGroup } from '@akin-home/aws-cognito';
import { showErrorToast, showSuccessToast } from '@akin-home/toast/native';
import { isRobotUser } from '@akin-home/utils/native';
import { useMutation, UseMutationOptions } from 'react-query';

export const useEditRobotMode = (
  options?: UseMutationOptions<void, unknown, string, unknown>
) => {
  const { onSuccess, onError, ...otherOptions } = options ?? {};

  const toEnableRobotUser = !isRobotUser();
  const signOut = useSignOut();

  const robotModeMutation = useMutation({
    mutationFn: async (username: string) => {
      if (toEnableRobotUser) {
        await adminAddUserToGroup({
          username: username,
          groupname: CognitoUserGroup.ROBOT_USERS,
        });
      } else {
        await adminRemoveUserFromGroup({
          username: username,
          groupname: CognitoUserGroup.ROBOT_USERS,
        });
      }
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);

      console.error('Error in toggling robot user', error);
      showErrorToast({
        text1: `Failed to ${toEnableRobotUser ? 'enable' : 'disable'} robot mode`,
        text2: 'Please try again',
      });
    },
    onSuccess: (data, variables, context) => {
      onSuccess?.(data, variables, context);

      showSuccessToast({
        text1: `${toEnableRobotUser ? 'Enabled' : 'Disabled'} robot mode`,
      });

      try {
        signOut();
      } catch (err) {
        console.error('Error in signing out', err);
        showErrorToast({
          text1: `Error in Signing Out`,
          text2: 'Please sign out manually',
        });
      }
    },
    ...otherOptions,
  });

  return robotModeMutation;
};
